import { render, staticRenderFns } from "./CreateMaterialCategoryPopup.vue?vue&type=template&id=659020d6"
import script from "./CreateMaterialCategoryPopup.vue?vue&type=script&lang=js"
export * from "./CreateMaterialCategoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports